import Vue from "vue";
import Vuex from "vuex";
import API_CLIENTS from "../../api/clients.api";

Vue.use(Vuex);

export const INITIAL_STATE = {
  clients: [],
  selectedClient: null,
  clientLogo: null,
};

export default {
  state: () => ({ ...INITIAL_STATE }),
  getters: {
    clients: (state) => state.clients,
    clientsSorted: (state) =>
      state.clients.sort((a, b) => {
        if (a.displayname.toLowerCase() < b.displayname.toLowerCase())
          return -1;
        if (a.displayname.toLowerCase() > b.displayname.toLowerCase()) return 1;
        return 0;
      }),
    isClientAlreadyExist:
      (state) =>
      (newClient = { displayname: "" }) => {
        const sameName = state.clients.filter(
          (client) =>
            client.enterpriseId.toLowerCase().trim() ===
              newClient.displayname.toLowerCase().trim() ||
            client.displayname.toLowerCase().trim() ===
              newClient.displayname.toLowerCase().trim()
        );
        return sameName.length > 0;
      },
    isClientCreating: (state) =>
      state.clients.find((client) => client.stackstatus == "CREATING"),
    selectedClient: (state) => state.selectedClient,
    selectedClientDataUpdate: (state) => ({
      maincolor: state.maincolor,
      displayname: state.maincolor,
      adminemail: state.adminemail,
      logo: state.logo,
      id: state.id,
    }),
  },
  mutations: {
    fetch_clients(state, newContent) {
      state.clients = newContent;
    },
    set_selected_client(state, newContent) {
      state.selectedClient = newContent;
    },
    update_client_image_URL(state, imageURL) {
      state.selectedClient.logo = imageURL;
    },
  },
  actions: {
    async fetch_clients({ commit, dispatch }) {
      const response = await API_CLIENTS.getClients();
      commit("fetch_clients", response);
      dispatch("update_selected_client_from_client_list");
      return "OK";
    },

    update_selected_client_from_client_list({ commit, getters }) {
      const selectedClientId = getters.selectedClient?.id;
      if (selectedClientId) {
        const selectedClient = getters.clients.find(
          (client) => client.id === selectedClientId
        );
        commit("set_selected_client", selectedClient);
      }
    },

    set_selected_client({ commit, dispatch }, client) {
      commit("set_selected_client", client);
      dispatch("fetch_attributes");
    },

    update_image_url({ getters, commit }, imageLogo) {
      const splitImageName = imageLogo.name.split(".");
      const imgType = splitImageName[splitImageName.length - 1];
      const clientId = getters.selectedClient.enterpriseId;
      const imageURL = `https://s3.eu-central-1.amazonaws.com/dynapark.assets/${clientId}/logo.${imgType}`;
      commit("update_client_image_URL", imageURL);
    },

    async update_logo({ getters, commit }, imageLogo) {
      // -- GET SIGNED URL
      if (imageLogo) {
        const splitImageName = imageLogo.name.split(".");
        const imgType = splitImageName[splitImageName.length - 1];
        const clientId = getters.selectedClient.enterpriseId;
        const signedURL = await API_CLIENTS.getLogoSignedUrl(clientId, imgType);
        await API_CLIENTS.updateLogo(signedURL, imageLogo);
        const imageURL = signedURL.split("?")[0];
        commit("update_client_image_URL", imageURL);
      }
      return "OK";
    },

    async update_selected_client({ getters, dispatch }) {
      // -- GET SIGNED URL
      const clientId = getters.selectedClient.id;
      const selectedClient = getters.selectedClient;
      const data = {
        ...(selectedClient.maincolor && {
          maincolor: selectedClient.maincolor,
        }),
        ...(selectedClient.displayname && {
          displayname: selectedClient.displayname,
        }),
        ...(selectedClient.adminemail && {
          adminemail: selectedClient.adminemail,
        }),
        ...(selectedClient.logo && {
          logo: selectedClient.logo,
        }),
        id: selectedClient.id,
      };
      await API_CLIENTS.updateClientInfo(clientId, data);
      dispatch("fetch_clients");
      return "OK";
    },

    async post_new_client({ dispatch }, data) {
      await API_CLIENTS.createNewClient(data);
      await dispatch("fetch_clients");
      return "OK";
    },
  },
};
